/* INTEGY V786 | SKU-family color alternatives. Lazy, availability-verified, never substitutes B2B retail prices. */
(function(){
  'use strict';
  if (window.IntegyV786Colors || !document.body || !/template-(index|collection|search|product)/.test(document.body.className)) return;
  window.IntegyV786Colors=true;
  var names=[
    ['DARKGREEN','Dark green','#207244'],['LIGHTGREEN','Light green','#79b86e'],['LIGHTBLUE','Light blue','#7cb5e5'],
    ['DARKBLUE','Dark blue','#154d94'],['DARKRED','Dark red','#862d35'],['DARKGREY','Dark grey','#525862'],
    ['GUNMETAL','Gunmetal','#59636b'],['TITANIUM','Titanium','#a9aaa4'],['CHAMPAGNE','Champagne','#d6b98d'],
    ['FLUORESCENTGREEN','Fluorescent green','#9fdb23'],['FLUORESCENTORANGE','Fluorescent orange','#ff7d17'],
    ['NEONGREEN','Neon green','#88cd35'],['NEONORANGE','Neon orange','#ff8225'],
    ['SILVER','Silver','#bbc3c9'],['ORANGE','Orange','#e98329'],['PURPLE','Purple','#8755ae'],
    ['YELLOW','Yellow','#e2be20'],['GOLD','Gold','#c7a34a'],['GREEN','Green','#23844f'],
    ['BLACK','Black','#222933'],['WHITE','White','#f7f8f9'],['GREY','Grey','#858a8f'],['GRAY','Grey','#858a8f'],
    ['BLUE','Blue','#2865c5'],['PINK','Pink','#db79ac'],['BROWN','Brown','#93603e'],['GUN','Gunmetal','#59636b'],
    ['RED','Red','#cf343f'],['TAN','Tan','#b59d7e']
  ].sort(function(a,b){return b[0].length-a[0].length;});
  var promises=new Map(), queue=[], active=0;
  var observer=null, queued=false, watchTargets=new WeakMap();
  var colorsRe=/\b(?:black|blue|red|green|orange|purple|silver|gold|yellow|white|grey|gray|gunmetal|gun|pink|brown|tan|titanium|champagne|dark green|light blue|dark blue|dark red|dark grey|neon green|neon orange)\b/gi;
  function normalizedTitle(title){return String(title||'').toLowerCase().replace(colorsRe,'').replace(/\s+/g,' ').replace(/[^a-z0-9]+/g,'').trim();}
  function familyFor(sku){
    sku=String(sku||'').trim().toUpperCase().replace(/[^A-Z0-9]/g,'');
    if(sku.length<6||sku.length>46)return null;
    for(var i=0;i<names.length;i++){
      if(sku.endsWith(names[i][0]) && sku.length-names[i][0].length>=4){
        return {base:sku.slice(0,-names[i][0].length),current:names[i][1]};
      }
    }
    return null;
  }
  function colorForHandle(handle,base){
    var h=String(handle||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    for(var i=0;i<names.length;i++) if(h.endsWith(base+names[i][0]))return names[i];
    return null;
  }
  function getFamily(base){
    if(promises.has(base))return promises.get(base);
    var url=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'search/suggest.json';
    var params=new URLSearchParams();
    params.set('q',base);
    params.set('resources[type]','product');
    params.set('resources[limit]','10');
    params.set('resources[options][unavailable_products]','hide');
    var promise=fetch(url+'?'+params.toString(),{credentials:'same-origin',headers:{Accept:'application/json'}})
      .then(function(response){if(!response.ok)throw Error('Color lookup failed');return response.json();})
      .then(function(data){return data&&data.resources&&data.resources.results&&data.resources.results.products||[];})
      .catch(function(){return [];});
    promises.set(base,promise);
    return promise;
  }
  function render(node,info,products){
    if(!node.isConnected)return;
    var target=normalizedTitle(node.getAttribute('data-title'));
    if(!target)return;
    var found=[], seen=new Set();
    products.forEach(function(product){
      if(!product||!product.available||normalizedTitle(product.title)!==target)return;
      var color=colorForHandle(product.handle,info.base);
      if(!color||color[1]===info.current||seen.has(color[1]))return;
      /* Derive links from each product's own unique handle.
         Predictive-search product.url may be rewritten to the source product
         on collections; it must not be reused for variant alternatives. */
      var slug=String(product.handle||'').trim().toLowerCase();
      if(!/^[a-z0-9][a-z0-9-]*$/.test(slug))return;
      var route=String(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/');
      if(!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(route))route='/';
      var path=route.replace(/\/$/,'')+'/products/'+slug;
      found.push({name:color[1],hex:color[2],url:path,sku:info.base+color[0]});
      seen.add(color[1]);
    });
    if(!found.length)return;
    found.sort(function(a,b){return a.name.localeCompare(b.name);});
    var title=document.createElement('strong');
    title.className='integy-v786-color-label';
    /* V790.1: short label only on cards; product detail keeps full text. */
    var compactListCard=!!node.closest('.productgrid--item,.integy-v529-search-card,.integy-v426-search-card');
    title.textContent=compactListCard
      ? (node.getAttribute('data-available')==='false' ? 'Other colors:' : 'Colors:')
      : (node.getAttribute('data-available')==='false' ? info.current+' sold out — try another color:' : 'Also available in:');
    var wrap=document.createElement('div');
    wrap.className='integy-v786-color-buttons';
    var compactColors = compactListCard && !node.classList.contains('integy-v786-predictive-color-options');
    var shown = 4;
    if (compactColors) {
      node.classList.add('integy-v790-dot-swatch-list');
      node.setAttribute('role','group');
      node.setAttribute('aria-label','Available alternative colors for this product');
      title.classList.add('visually-hidden');
    }
    found.forEach(function(p,index){
      var link=document.createElement('a');
      link.className='integy-v786-color-link';
      link.href=p.url;
      link.setAttribute('data-integy-v790-canonical-href',p.url);
      link.setAttribute('data-integy-v790-target-sku',p.sku);
      /* Older card hover scripts must not replace the color destination. */
      link.addEventListener('pointerenter',function(){
        var wanted=link.getAttribute('data-integy-v790-canonical-href');
        if(wanted&&link.getAttribute('href')!==wanted)link.setAttribute('href',wanted);
      },{passive:true});
      link.addEventListener('focus',function(){
        var wanted=link.getAttribute('data-integy-v790-canonical-href');
        if(wanted&&link.getAttribute('href')!==wanted)link.setAttribute('href',wanted);
      });
      link.setAttribute('aria-label','View '+p.name+' color — SKU '+p.sku+' — in stock');
      link.title=p.name+' — in stock';
      if(compactColors){
        link.classList.add('integy-v790-swatch-only');
        if(index>=shown){
          link.classList.add('integy-v790-swatch-extra');
          link.hidden=true;
        }
      }
      var dot=document.createElement('span');
      dot.className='integy-v786-color-dot';
      dot.style.backgroundColor=p.hex;
      dot.setAttribute('aria-hidden','true');
      link.appendChild(dot);
      if(!compactColors)link.appendChild(document.createTextNode(p.name));
      wrap.appendChild(link);
    });
    if(compactColors && found.length>shown) {
      var more=document.createElement('button');
      more.type='button';
      more.className='integy-v790-swatch-more';
      more.setAttribute('aria-expanded','false');
      more.setAttribute('aria-label','Show '+(found.length-shown)+' more available colors');
      more.textContent='+'+(found.length-shown);
      more.addEventListener('click',function(){
        var expanded=more.getAttribute('aria-expanded')==='true';
        wrap.querySelectorAll('.integy-v790-swatch-extra').forEach(function(link){
          link.hidden=expanded;
        });
        more.setAttribute('aria-expanded',expanded?'false':'true');
        more.textContent=expanded?'+'+(found.length-shown):'−';
        more.setAttribute('aria-label',expanded?'Show '+(found.length-shown)+' more available colors':'Hide extra colors');
      });
      wrap.appendChild(more);
    }
    node.appendChild(title);
    node.appendChild(wrap);
    /* V790.5: purchase action must be the bottom row on cards. */
    if (compactListCard) {
      var cardHost=node.closest('.productitem--info,.integy-v426-search-card__body');
      var orderPanel=cardHost&&cardHost.querySelector('.productitem--actions,[data-product-actions]');
      if(cardHost && orderPanel && node.parentNode===cardHost)cardHost.insertBefore(node,orderPanel);
    }
    node.hidden=false;
  }
  function execute(job){
    active++;
    getFamily(job.info.base).then(function(list){render(job.node,job.info,list);})
      .finally(function(){active--;next();});
  }
  function next(){while(active<2&&queue.length)execute(queue.shift());}
  function request(node){
    if(node.dataset.integyV786Loaded==='yes')return;
    node.dataset.integyV786Loaded='yes';
    var info=familyFor(node.getAttribute('data-sku'));
    if(!info)return;
    queue.push({node:node,info:info});next();
  }
  function insertSearchOptions(){
    /* Existing predictive suggestions are entire links; add a sibling, never nest links inside links. */
    document.querySelectorAll('#integy-v520-search-panel a.integy-v520-search-product[data-sku]:not([data-integy-v786-prepared])').forEach(function(anchor){
      anchor.setAttribute('data-integy-v786-prepared','true');
      var sku=anchor.getAttribute('data-sku')||'';
      if(!familyFor(sku))return;
      var title=anchor.querySelector('.integy-v520-search-product__copy strong');
      if(!title)return;
      var node=document.createElement('div');
      node.className='integy-v786-color-options integy-v786-predictive-color-options';
      node.setAttribute('data-integy-v786-color-options','');
      node.setAttribute('data-sku',sku);
      node.setAttribute('data-title',title.getAttribute('data-full-title')||title.textContent||'');
      node.setAttribute('data-available',anchor.querySelector('.is-sold-out')?'false':'unknown');
      node.hidden=true;
      anchor.insertAdjacentElement('afterend',node);
    });
    /* Client-rendered full-search cards use a different template than Shopify Liquid. */
    document.querySelectorAll('[data-integy-v529-search-card="true"][data-sku]:not([data-integy-v786-prepared])').forEach(function(card){
      card.setAttribute('data-integy-v786-prepared','true');
      var sku=card.getAttribute('data-sku')||'';
      if(!familyFor(sku))return;
      var title=card.querySelector('.integy-v426-search-card__body h2,.productitem--title');
      var host=card.querySelector('.integy-v426-search-card__body,.productitem--info');
      if(!title||!host||host.querySelector('[data-integy-v786-color-options]'))return;
      var node=document.createElement('div');
      node.className='integy-v786-color-options';
      node.setAttribute('data-integy-v786-color-options','');
      node.setAttribute('data-sku',sku);
      node.setAttribute('data-title',title.getAttribute('data-full-title')||title.textContent||'');
      node.setAttribute('data-available',card.getAttribute('data-product-available')||'unknown');
      node.hidden=true;
      host.appendChild(node);
    });
  }
  /* V787: stock-filtered /collections/all is rendered from a JS product snapshot.
     Its cards have no Liquid color placeholder, so insert one when cards appear. */
  function insertCollectionOptions(){
    document.querySelectorAll('[data-integy-v715-all-card="true"][data-sku]:not([data-integy-v787-color-prepared])').forEach(function(card){
      card.setAttribute('data-integy-v787-color-prepared','true');
      if(card.querySelector('[data-integy-v786-color-options]'))return;
      var sku=card.getAttribute('data-sku')||'';
      if(!familyFor(sku))return;
      var title=card.querySelector('.productitem--title a,.productitem--title');
      var host=card.querySelector('.productitem--info');
      if(!title||!host)return;
      var node=document.createElement('div');
      node.className='integy-v786-color-options';
      node.setAttribute('data-integy-v786-color-options','');
      node.setAttribute('data-sku',sku);
      node.setAttribute('data-title',title.getAttribute('data-full-title')||title.textContent||'');
      node.setAttribute('data-available',card.getAttribute('data-product-available')||'unknown');
      node.hidden=true;
      host.appendChild(node);
    });
  }
  function scan(){
    queued=false;
    insertSearchOptions();
    insertCollectionOptions();
    var nodes=document.querySelectorAll('[data-integy-v786-color-options]:not([data-integy-v786-watched])');
    nodes.forEach(function(node){
      node.setAttribute('data-integy-v786-watched','true');
      if(!familyFor(node.getAttribute('data-sku')))return;
      /* IntersectionObserver loads color families only when they approach view;
         do not permanently exclude products below the first 32 cards. */
      if(observer){
        var anchor=(node.classList.contains('integy-v786-predictive-color-options')?node.previousElementSibling:null)||
          node.closest('[data-product-item]')||node.closest('.product-block')||node.parentElement;
        if(anchor){watchTargets.set(anchor,node);observer.observe(anchor);}else request(node);
      }else request(node);
    });
  }
  function schedule(){if(queued)return;queued=true;window.requestAnimationFrame(scan);}
  if(window.IntersectionObserver){
    observer=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){observer.unobserve(e.target);var target=watchTargets.get(e.target);if(target)request(target);}});},{rootMargin:'250px'});
  }
  /* V790.18: Color selections are real canonical product links.
     Shopify predictive search already confirmed same title + exact SKU-color
     suffix + availability when the swatch was rendered. Re-fetching product
     JSON on every click caused intermittent stuck navigation on slow/blocked
     requests. Let the browser follow the verified href itself, including
     keyboard and open-in-new-tab gestures; stop old card click handlers
     from intercepting the selected color. */
  window.addEventListener('click',function(event){
    var link=event.target && event.target.closest
      ? event.target.closest('a.integy-v786-color-link[data-integy-v790-target-sku]') : null;
    if(!link)return;
    var canonical=link.getAttribute('data-integy-v790-canonical-href')||link.getAttribute('href')||'';
    var expected=String(link.getAttribute('data-integy-v790-target-sku')||'').toUpperCase();
    var destination;
    try{destination=new URL(canonical,location.origin);}catch(error){return;}
    if(destination.origin!==location.origin ||
      !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+\/?$/i.test(destination.pathname) ||
      !/^[A-Z0-9]{5,48}$/.test(expected) ||
      !destination.pathname.toUpperCase().replace(/[^A-Z0-9]/g,'').endsWith(expected))return;
    /* Preserve draft preview only when it is explicitly present in the
       current URL. The published storefront receives a plain canonical URL. */
    try{
      var preview=new URLSearchParams(location.search||'').get('preview_theme_id');
      if(preview==='189799203068')destination.searchParams.set('preview_theme_id',preview);
    }catch(error){}
    link.setAttribute('href',destination.pathname+destination.search+destination.hash);
    event.stopPropagation();
    /* Deliberately do NOT preventDefault: native link navigation must work. */
  },true);

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
  if(window.MutationObserver){
    new MutationObserver(function(records){
      if(records.some(function(r){return Array.prototype.some.call(r.addedNodes||[],function(n){return n.nodeType===1&&(n.matches&&n.matches('[data-integy-v786-color-options],#integy-v520-search-panel,[data-integy-v529-search-card],[data-integy-v715-all-card]')||n.querySelector&&n.querySelector('[data-integy-v786-color-options],.integy-v520-search-product,[data-integy-v529-search-card],[data-integy-v715-all-card]'));});}))schedule();
    }).observe(document.body,{subtree:true,childList:true});
  }
})();